// Payment status constants
export const PAYMENT_STATUS = {
  PAYSUCCESS: "PAYSUCCESS",
  UNPROCESS: "UNPROCESS",
  CANCEL: "CANCEL",
  RETURN: "RETURN",
} as const;
